import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TPatchCanadianPayrollBusinessEntityRequest,
  TPatchCanadianPayrollBusinessEntityResponse,
} from "./patchCanadianPayrollBusinessEntity.schema";

export const patchCanadianPayrollBusinessEntity = (axios: IAxiosInstance) => {
  return async (
    body: TPatchCanadianPayrollBusinessEntityRequest
  ): Promise<TPatchCanadianPayrollBusinessEntityResponse> => {
    const response = await axios.noRetry.patch<
      ZealApiResponse<TPatchCanadianPayrollBusinessEntityResponse>
    >("/api/canadian-payroll/business-entity", body);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
